const indexItems = [
  { title: '电视剧大全', desc: '国产剧·韩剧·美剧·日剧', icon: 'ri-tv-2-line', count: '8500+', color: 'bg-primary-100 text-primary-500' },
  { title: '电影片库', desc: '动作·喜剧·科幻·悬疑', icon: 'ri-film-line', count: '12000+', color: 'bg-accent-100 text-accent-500' },
  { title: '综艺娱乐', desc: '真人秀·脱口秀·音乐', icon: 'ri-emotion-laugh-line', count: '3200+', color: 'bg-secondary-100 text-secondary-500' },
  { title: '动漫番剧', desc: '国漫·日漫·剧场版', icon: 'ri-ghost-line', count: '5600+', color: 'bg-primary-100 text-primary-500' },
  { title: '纪录片', desc: '自然·历史·人文·科技', icon: 'ri-earth-line', count: '2100+', color: 'bg-accent-100 text-accent-500' },
  { title: '儿童专区', desc: '动画·教育·亲子', icon: 'ri-parent-line', count: '1800+', color: 'bg-secondary-100 text-secondary-500' },
  { title: '短剧剧场', desc: '微短剧·竖屏剧·迷你剧', icon: 'ri-smartphone-line', count: '950+', color: 'bg-primary-100 text-primary-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            全站索引
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            探索全部内容分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型快速找到你想看的内容，剧集、电影、综艺、动漫一应俱全
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col items-center"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl ${item.color} mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-400 mb-2">{item.desc}</p>
              <span className="text-xs font-heading font-bold text-primary-500">{item.count} 部</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}